import RequestList from '@/views/request/List.vue'
import RequestSingle from '@/views/request/Single.vue'

export default [
  {
    path: '/rl',
    name: 'request-list',
    component: RequestList,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'request-list',
          title: 'Requests'
        }
      ]
    }
  },
  {
    path: '/rs/:id',
    name: 'request-single',
    component: RequestSingle,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'request-list',
          title: 'Requests'
        },
        {
          link: 'request-single',
          title: 'Request Single',
          params: 'id'
        }
      ]
    }
  }
]
